import { render, staticRenderFns } from "./DownPaymentStep.vue?vue&type=template&id=b2961f24&scoped=true&"
import script from "./DownPaymentStep.vue?vue&type=script&lang=js&"
export * from "./DownPaymentStep.vue?vue&type=script&lang=js&"
import style0 from "./DownPaymentStep.vue?vue&type=style&index=0&id=b2961f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2961f24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
